<template>
    <div class="main_reports">

        <div class="input_search mb-4">
            <input v-model="model_find" @keypress.enter="findname" type="text" placeholder="Search" class="form-control">
            <svg @click="findname" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"/>
            </svg>
        </div>
        <div class="d-flex justify-content-between">
            <div>
                <button @click="addReport" class="btn btn-border">+ NEW REPORT</button>
                <button @click.prevent="deleteCheckList" class="btn" :class="[ listdelete.length > 0 ? 'btn-border' : 'btn-border-light']">DELETE</button>
            </div>
            <div></div>
        </div>

        <table class="table mt-5 fz08">
            <tr class="fz08">
                <th>
                    <div class="d-flex align-items-center">
                        <div class="">
                            <input v-model="model_all" @change="checkAll" id="top" type="checkbox" class="custom_checkbox">
                            <label for="top"></label>
                        </div>
                        <span @click="sortName" class="cursor_pointer">
                            <iconsort :updown="sort_name"></iconsort>
                            <span>Name</span>
                        </span>
                    </div>
                </th>
                <th>
                    <span class="cursor_pointer">
                        <iconsort :updown="sort_date"></iconsort>
                        <span>Creation date</span>
                    </span>
                </th>
                <th>Begin time</th>
                <th>End time</th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
            <tr v-for="(report, key) in reportsItem" :key="report.id" class="black_line" :class="[( report.status_id === 4 ) ? 'black_line_done' : '']">
                <td>
                    <div class="avatar_and_title d-flex justify-content-start">
                        <div class="">
                            <input v-model="report.checked" @change="changeItem" :id="`t_${key}`" type="checkbox" class="custom_checkbox">
                            <label :for="`t_${key}`">{{report.name}}</label>
                        </div>
                    </div>
                </td>
                <td>{{report.created_at}}</td>
                <td class="text-center">{{report.date_begin}}</td>
                <td class="text-center">{{report.date_end}}</td>
                <td><a :href="`/reports/${report.id}?export=1`" class="btn btn-link btn-sm">EXPORT</a></td>
                <td><a :href="`/reports/${report.id}`" class="btn btn-link btn-sm">SHOW REPORT</a></td>
                <td>
                    <div class="dotscontrol" >
                        <div class="dotscontrol_dots" type="button" :id="`dropdownMenuButton${key}`" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="dotscontrol_dots__span"></span>
                        </div>
                        <ul class="dropdown-menu" :aria-labelledby="`dropdownMenuButton${key}`">
                            <li><a @click="editReport(report)" class="dropdown-item" href="#">EDIT</a></li>
                            <li> <a @click="deleteReport(report.id)" class="dropdown-item" >DELETE</a></li>
                        </ul>
                    </div>
                </td>
            </tr>


        </table>

        <div class="bottom_panel d-flex align-items-center justify-content-between mt-5">
            
            <div class="bottom_panel_right">
                <div class="label_and_input_line d-flex">
                    <label for="select_count_item">Show:</label>
                    <select v-model="model_counitempage" @change="getResults" id="select_count_item" class="form-select" aria-label="Default select example">                        
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="200">100</option>
                    </select>
                </div>

                <pagin  align="center" :data="data" @pagination-change-page="getResults">
                    <span slot="prev-nav">
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.91456 0.958033L2.00028 7.04255L8.0848 12.9568" stroke="white" stroke-width="2"/>
                        </svg>
                    </span>
                    <span slot="next-nav">
                        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.999999 13L7 7L0.999999 1" stroke="white" stroke-width="2"/>
                        </svg>
                    </span>
                </pagin>

                <div class="label_and_input_line d-flex">
                    <label for="to_page">Move to page:</label>
                    <input @keypress.enter="event => getResults(event.target.value)" type="number" class="form-control" id="to_page" min="1">
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import {bus} from '../bus';
import axios from 'axios';
import Pagin from 'laravel-vue-pagination';

import ReportCardList from "./Reports/ReportCardList";

import Dotscontrol from './Dotscontrol';
import iconsort from "./iconsort";
import hrdate from "./hrdate";
import statusvideo from "./statusvideo";

export default {
    data(){
        return{
            data: {},
            sort: 'id',
            sorttype: 'desc',
            sort_name: 'up',
            sort_person: 'up',
            sort_date: 'up',
            model_all: false,
            listdelete: [],
            btn_delete_all: true,

            model_counitempage: 25,
            model_find: '',

            reports: [],
            sort_status: 'up',
        }
    },
    methods: {
        findname(){
            this.getResults();
        },
        syncSelection(){
            this.listdelete = [];
            this.reports.forEach((item) => {
                if (item.checked) {
                    this.listdelete.push(item.id);
                }
            });
            this.model_all = this.reports.length > 0
                && this.reports.every((item) => item.checked);
        },
        clearCheck(){
            this.reports.forEach((item) => {
                item.checked = false;
            });
            this.syncSelection();
        },
        getResults(page = 1) {
            window.scrollTo(0,0);
            const url = `/reports/`;
            const params = {                
                page: page,
                countitempage: this.model_counitempage,
                sort: this.sort,
                sorttype: this.sorttype,
                name: this.model_find,
                short: 'y'
            }            
            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }
            ).then((response) => {
                this.data = response.data;
                this.reports = (response.data.data || []).map((item) => {
                    item.checked = !!item.checked;
                    return item;
                });
                // Page/filter refresh — master must match visible rows.
                this.syncSelection();

            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        },
        addReport(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formreport',
                'crud': 'create',
                'title_form': 'Create new report',
                'report': {
                    "name": "",
                    "video_id": [],
                    "person_id": [],
                    "date_begin": "",
                    "date_end": ""
                }
            })
        },
        editReport(report){            
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formreport',
                'crud': 'update',
                'title_form': 'Update report',
                'report': report,
                'addPopupClass': 'editreport'
            })
        },
        deleteReport(id){
            axios.delete(`/reports/${id}`
            ).then((responce)=>{
                console.log('delete report', responce);
                this.getResults();
                this.model_all = false;
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        deleteCheckList(){
            this.listdelete.map((item) => {
                this.deleteReport(item);
            });
            this.listdelete = [];
            this.getResults();
            
            
            this.reports.map((item, key) => {
                    item.checked = false;
            });

            this.model_all = false;

        },
        sortName(){

            if(this.sort_name === 'up'){
                this.sort_name = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_name = 'up';
                this.sorttype = 'asc';
            }
            this.getResults();
        },
        sortPerson(){

            if(this.sort_person === 'up'){
                this.sort_person = 'down';
            }else{
                this.sort_person = 'up';
            }
        },
        sortStatus(){

            this.sort = 'status_id';


            if(this.sort_status === 'up'){
                this.sort_status = 'down';
                this.sorttype = 'desc';
            }else{
                this.sort_status = 'up';
                this.sorttype = 'asc';
            }
            this.getResults();

        },
        checkAll(){
            const checked = !!this.model_all;
            this.reports.forEach((item) => {
                item.checked = checked;
            });
            this.syncSelection();
        },
        changeItem(){
            this.syncSelection();
        },
        convertUnixTime(unix_timestamp){
            let date = new Date(unix_timestamp * 1000);
            let day = date.getDate();
            let month = date.getMonth()+1;
            let year = date.getFullYear();
            let hours = date.getHours();
            let minutes = "0" + date.getMinutes();
            let seconds = "0" + date.getSeconds();
            if( day === 1 ||
                day === 2 ||
                day === 3 ||
                day === 4 ||
                day === 5 ||
                day === 6 ||
                day === 7 ||
                day === 8 ||
                day === 9){
                day = '0'+day;
            }
            if( month === 1 ||
                month === 2 ||
                month === 3 ||
                month === 4 ||
                month === 5 ||
                month === 6 ||
                month === 7 ||
                month === 8 ||
                month === 9){
                month = '0'+month;
            }

            let formattedTime = day+ ':' +month+ ':' +year+ ' ' +hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

            return formattedTime;
        },
    },
    watch: {

    },
    mounted(){
        this.getResults();
        bus.$on('updatereports', () => {
            this.getResults();
        });
    },
    computed: {
        reportsItem(){
            this.reports.map((item) => {
                item.checked = false;
                item.opensetting = false;
            });
            return this.reports;
        },
    },
    components: {
        Pagin,
        ReportCardList,
        Dotscontrol,
        iconsort,
        hrdate,
        statusvideo
    }
}
</script>

<style lang="scss" scoped>    
</style>
